import { useQuery } from '@tanstack/react-query';
import clientApi from '~/clientApi';
import { AGENCY_TOKEN } from '~/queries/keys';

export const useListAgencies = (slug: string, options = {}) => {
  return useQuery([AGENCY_TOKEN, slug], () => clientApi.getAgencies(slug), {
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options,
  });
};
